import React, { useContext, useEffect, useState } from 'react';
import $ from 'jquery';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { Box, Button, Paper, Stack, TextField } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { formatToPhone } from 'brazilian-values';
import { parseCpfCnpj, parsePhone } from '../../../../helpers/parseValues';
import { useAuth } from '../../../../hooks/Auth';
import { StepButtons } from '../StepButtons';

import {
  Title,
  TooltipIcon,
  TooltipWrapper,
  BtnWrapper,
  FixedButton,
  FieldsInLineLayout,
  InputContainerWidthNumber,
  SectionTitle,
  SectionTitleContainer
} from './styled';
import { ReverseCollectContext } from '../..';
import { useIntegration } from '../../../../hooks/Integration';

export const RequesterData = () => {
  // const [contactNumber, setContactNumber] = useState('');
  const [isRequiredAlternativeContact, setIsRequiredAlternativeContact] =
    useState(false);
  const [isRequiredAlternativeContact2, setIsRequiredAlternativeContact2] =
    useState(false);
  const [alternativeContactNumber, setAlternativeContactNumber] = useState('');
  const [alternativeContactIsRequired, setAlternativeContactIsRequired] =
    useState(false);

  const { user } = useAuth();

  const maxXS = useMediaQuery('(max-width:480px)');
  const maxSM = useMediaQuery('(max-width:768px)');
  const maxMD = useMediaQuery('(max-width:900px)');

  const {
    addressList,
    selectedAddressIndex,
    handleNextStep,
    requesterContact,
    collectRequesterData,
    setCollectRequesterData,
    setCollectRecipientData,
    clientInternalCode,
    setClientInternalCode,
    knowledgeNumber,
    openChangeRequesterDataModal,
    contactName,
    setContactName,
    contactEmail,
    setContactEmail,
    phoneNumber,
    setPhoneNumber,
    contactRamal,
    setContactRamal,
    alternativeContactName,
    setAlternativeContactName,
    alternativeContactEmail,
    setAlternativeContactEmail,
    alternativeContactPhone,
    setAlternativeContactPhone,
    alternativeContactExtension,
    setAlternativeContactExtension,
    alternativeContactName2,
    setAlternativeContactName2,
    alternativeContactEmail2,
    setAlternativeContactEmail2,
    alternativeContactPhone2,
    setAlternativeContactPhone2,
    alternativeContactExtension2,
    setAlternativeContactExtension2,
    alternativeContact,
    setAlternativeContact,
    alternativeContact2,
    setAlternativeContact2,
    setProtocolCollectCanceled
  } = useContext(ReverseCollectContext);

  const collectRequesterSchema = Yup.object().shape({
    clientInternalCode: Yup.string(),
    contactName: Yup.string().required('Nome obrigatório'),
    contactEmail: Yup.string()
      .required('E-mail obrigatório')
      .trim('E-mail obrigatório')
      .matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido'),
    phoneNumber: Yup.string()
      .required('Telefone obrigatório')
      .trim('Telefone obrigatório')
      .test('validatePhoneNumber', 'Telefone inválido', (value) => {
        if (value) {
          return parsePhone(value).length >= 10;
        }
        return false;
      }),
    extension: Yup.string(),
    alternativeContact: Yup.boolean(),

    alternativeContactName: isRequiredAlternativeContact
      ? Yup.string().required('Nome obrigatório')
      : Yup.string(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactEmail: isRequiredAlternativeContact ? Yup.string().required('E-mail obrigatório').matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido') : Yup.string(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactPhone: isRequiredAlternativeContact ? Yup.string().required('Telefone obrigatório').test('validatePhoneNumber', 'Telefone inválido', (value) => value ? parsePhone(value).length >= 10 : false) : Yup.string().nullable(),
    alternativeExtension: Yup.string().nullable(),

    alternativeContactName2: isRequiredAlternativeContact2
      ? Yup.string().required('Nome obrigatório')
      : Yup.string().nullable(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactEmail2: isRequiredAlternativeContact2 ? Yup.string().required('E-mail obrigatório').matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido') : Yup.string(),
    // eslint-disable-next-line prettier/prettier
    alternativeContactPhone2: isRequiredAlternativeContact2 ? Yup.string().required('Telefone obrigatório').test('validatePhoneNumber', 'Telefone inválido', (value) => value ? parsePhone(value).length >= 10 : false) : Yup.string().nullable(),
    alternativeExtension2: Yup.string().nullable()
  });

  const {
    handleSubmit,
    control,
    setValue,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(collectRequesterSchema),
    mode: 'onBlur',
    reValidateMode: 'onChange'
  });

  const onNextStep = async (data) => {
    // if (alternativeContactIsRequired) {
    //   let stopNextStep = false;

    //   if (data.alternativeContactName === '') {
    //     stopNextStep = true;
    //     setError('alternativeContactName', { message: 'Nome obrigatório' });
    //   }

    //   if (data.alternativeContactEmail === '') {
    //     stopNextStep = true;
    //     setError('alternativeContactEmail', { message: 'E-mail obrigatório' });
    //   }

    //   if (data.alternativePhoneNumber === '') {
    //     stopNextStep = true;
    //     setError('alternativePhoneNumber', {
    //       message: 'Telefone obrigatório'
    //     });
    //   } else if (parsePhone(data.alternativePhoneNumber).length < 10) {
    //     stopNextStep = true;
    //     setError('alternativePhoneNumber', {
    //       message: 'Telefone inválido'
    //     });
    //   }

    //   if (stopNextStep) {
    //     return;
    //   }
    // }

    setClientInternalCode(data.clientInternalCode);

    const contactList = [];

    contactList?.push({
      name: addressList[selectedAddressIndex]?.contactName
        ? addressList[selectedAddressIndex]?.contactName.toUpperCase()
        : data.contactName,
      phoneNumber: addressList[selectedAddressIndex]?.contactNumber,
      extension: addressList[selectedAddressIndex]?.contactExtension || '',
      email: addressList[selectedAddressIndex]?.contactEmail.toLowerCase()
    });

    contactList?.push({
      name: data.contactName,
      phoneNumber: parsePhone(data.phoneNumber),
      extension: data.extension,
      email: data.contactEmail
    });

    alternativeContact &&
      isRequiredAlternativeContact &&
      contactList.push({
        name: data.alternativeContactName,
        phoneNumber: parsePhone(data.alternativeContactPhone),
        extension: data.alternativeExtension,
        email: data.alternativeContactEmail
      });

    alternativeContact2 &&
      isRequiredAlternativeContact2 &&
      contactList.push({
        name: data.alternativeContactName2,
        phoneNumber: parsePhone(data.alternativeContactPhone2),
        extension: data.alternativeExtension2,
        email: data.alternativeContactEmail2
      });
    const requester = {
      document: addressList[selectedAddressIndex]?.document
        ? parseCpfCnpj(addressList[selectedAddressIndex]?.document)
        : user.document,
      name: addressList[selectedAddressIndex]?.name || user.name,
      address: {
        zipPostalCode: parseCpfCnpj(
          addressList[selectedAddressIndex]?.zipPostalCode
        ),
        streetAddress: addressList[selectedAddressIndex].streetAddress,
        streetAddressNumber:
          addressList[selectedAddressIndex].streetAddressNumber,
        suburb: addressList[selectedAddressIndex].suburb,
        city: addressList[selectedAddressIndex].city,
        state: addressList[selectedAddressIndex].state,
        country: addressList[selectedAddressIndex].country || 'BRASIL',
        additionalInformation:
          addressList[selectedAddressIndex].additionalInformation || ''
      },
      contactList
    };

    setCollectRequesterData(requester);
    !knowledgeNumber && setCollectRecipientData(requester);

    handleNextStep();
  };

  const handleChangeRequesterData = () => {
    openChangeRequesterDataModal();
  };

  useEffect(() => {
    if (
      alternativeContactName !== '' ||
      alternativeContactEmail !== '' ||
      alternativeContactPhone !== ''
    ) {
      setAlternativeContact(true);
    }

    if (
      alternativeContactName2 !== '' ||
      alternativeContactEmail2 !== '' ||
      alternativeContactPhone2 !== ''
    ) {
      setAlternativeContact2(true);
    }
  }, []);

  const addContact = () => {
    if (alternativeContact === true) {
      setAlternativeContact2(true);
    }

    if (alternativeContact === false) {
      setAlternativeContact(true);
    }
  };

  useEffect(() => {
    $('#phoneNumber').mask('(00) 0000-00009');
  }, [phoneNumber]);

  useEffect(() => {
    $('#alternativeContactPhone').mask('(00) 0000-00009');
  }, [alternativeContactPhone]);

  useEffect(() => {
    $('#alternativeContactPhone2').mask('(00) 0000-00009');
  }, [alternativeContactPhone2]);

  useEffect(() => {
    const clear = [];

    if (requesterContact.contactName) {
      setValue('contactName', requesterContact.contactName.toUpperCase());
      clear.push('contactName');
    }

    if (requesterContact.contactEmail) {
      setValue('contactEmail', requesterContact.contactEmail.toLowerCase());
      clear.push('contactEmail');
    }

    if (requesterContact.phoneNumber) {
      setValue('phoneNumber', requesterContact.phoneNumber);
      setPhoneNumber(requesterContact.phoneNumber);
      clear.push('phoneNumber');
    }

    if (requesterContact.extension) {
      setValue('extension', requesterContact.extension);
      clear.push('extension');
    }

    clearErrors(clear);
  }, [JSON.stringify(requesterContact)]);

  useEffect(() => {
    clientInternalCode && setValue('clientInternalCode', clientInternalCode);

    if (collectRequesterData.contactList?.length > 1) {
      setValue(
        'contactName',
        collectRequesterData.contactList[1].name.toUpperCase()
      );
      setValue(
        'contactEmail',
        collectRequesterData.contactList[1].email.toLowerCase()
      );
      setValue('phoneNumber', collectRequesterData.contactList[1].phoneNumber);
      setValue('extension', collectRequesterData.contactList[1].extension);
      setPhoneNumber(collectRequesterData.contactList[1].phoneNumber);
    }

    if (collectRequesterData.contactList?.length > 2) {
      setAlternativeContact(true);
      setValue(
        'alternativeContactName',
        collectRequesterData.contactList[2].name.toUpperCase()
      );
      setValue(
        'alternativeContactEmail',
        collectRequesterData.contactList[2].email.toLowerCase()
      );
      setValue(
        'alternativeContactPhone',
        collectRequesterData.contactList[2].phoneNumber
      );
      setValue(
        'alternativeExtension',
        collectRequesterData.contactList[2].extension
      );

      setAlternativeContactName(collectRequesterData.contactList[2].name);
      setAlternativeContactEmail(collectRequesterData.contactList[2].email);
      setAlternativeContactPhone(
        collectRequesterData.contactList[2].phoneNumber
      );
      setAlternativeContactExtension(
        collectRequesterData.contactList[2].extension
      );
    } else {
      setAlternativeContact(false);
      setValue('alternativeContactName', '');
      setValue('alternativeContactEmail', '');
      setValue('alternativeContactPhone', '');
      setValue('alternativeExtension', '');

      setAlternativeContactName('');
      setAlternativeContactEmail('');
      setAlternativeContactPhone('');
      setAlternativeContactExtension('');
    }

    if (collectRequesterData.contactList?.length > 3) {
      setAlternativeContact2(true);
      setValue(
        'alternativeContactName2',
        collectRequesterData.contactList[3].name.toUpperCase()
      );
      setValue(
        'alternativeContactEmail2',
        collectRequesterData.contactList[3].email.toLowerCase()
      );
      setValue(
        'alternativeContactPhone2',
        collectRequesterData.contactList[3].phoneNumber
      );
      setValue(
        'alternativeExtension2',
        collectRequesterData.contactList[3].extension
      );

      setAlternativeContactName2(collectRequesterData.contactList[3].name);
      setAlternativeContactEmail2(collectRequesterData.contactList[3].email);
      setAlternativeContactPhone2(
        collectRequesterData.contactList[3].phoneNumber
      );
      setAlternativeContactExtension2(
        collectRequesterData.contactList[3].extension
      );
    } else {
      setAlternativeContact2(false);
      setValue('alternativeContactName2', '');
      setValue('alternativeContactEmail2', '');
      setValue('alternativeContactPhone2', '');
      setValue('alternativeExtension2', '');

      setAlternativeContactName2('');
      setAlternativeContactEmail2('');
      setAlternativeContactPhone2('');
      setAlternativeContactExtension2('');
    }
  }, []);

  const removeContactAlternative = () => {
    setAlternativeContactName('');
    setAlternativeContactEmail('');
    setAlternativeContactPhone('');
    setAlternativeContactExtension('');
    setValue('alternativeContactName', '');
    setValue('alternativeContactEmail', '');
    setValue('alternativeContactPhone', '');
    setValue('alternativeContactExtension', '');
  };

  const removeContactAlternative2 = () => {
    setAlternativeContactName2('');
    setAlternativeContactEmail2('');
    setAlternativeContactPhone2('');
    setAlternativeContactExtension2('');
    setValue('alternativeContactName2', '');
    setValue('alternativeContactEmail2', '');
    setValue('alternativeContactPhone2', '');
    setValue('alternativeContactExtension2', '');
  };

  useEffect(() => {
    if (
      alternativeContactName !== '' ||
      alternativeContactEmail !== '' ||
      alternativeContactPhone !== '' ||
      alternativeContactExtension !== ''
    ) {
      setIsRequiredAlternativeContact(true);
    } else {
      setIsRequiredAlternativeContact(false);
      clearErrors([
        'alternativeContactName',
        'alternativeContactEmail',
        'alternativeContactPhone'
      ]);
    }
  }, [
    alternativeContactName,
    alternativeContactEmail,
    alternativeContactPhone,
    alternativeContactExtension
  ]);

  useEffect(() => {
    if (
      alternativeContactName2 !== '' ||
      alternativeContactEmail2 !== '' ||
      alternativeContactPhone2 !== '' ||
      alternativeContactExtension2 !== ''
    ) {
      setIsRequiredAlternativeContact2(true);
    } else {
      setIsRequiredAlternativeContact2(false);
      clearErrors([
        'alternativeContactName2',
        'alternativeContactEmail2',
        'alternativeContactPhone2'
      ]);
    }
  }, [
    alternativeContactName2,
    alternativeContactEmail2,
    alternativeContactPhone2,
    alternativeContactExtension2
  ]);

  return (
    <form onSubmit={handleSubmit(onNextStep)}>
      <Paper
        elevation={2}
        style={{
          position: 'relative',
          marginTop: 16,
          padding: '20px 16px 16px'
        }}
      >
        <Box
          style={{
            display: 'flex',
            flexDirection: maxXS && 'column',
            justifyContent: 'space-between',
            marginBottom: maxMD && 16,
            gap: 8
          }}
        >
          <Title>Dados do Solicitante:</Title>

          <Button
            type="button"
            variant="contained"
            onClick={handleChangeRequesterData}
          >
            Alterar
          </Button>
        </Box>

        <Box>
          <p>
            {addressList[selectedAddressIndex]?.name} -{' '}
            {addressList[selectedAddressIndex]?.document}
          </p>
          <p>
            CEP: {addressList[selectedAddressIndex]?.zipPostalCode}
            {addressList[selectedAddressIndex]?.streetAddress && (
              <>, {addressList[selectedAddressIndex]?.streetAddress}</>
            )}
            {addressList[selectedAddressIndex]?.streetAddressNumber && (
              <>, {addressList[selectedAddressIndex]?.streetAddressNumber}</>
            )}
            {addressList[selectedAddressIndex]?.additionalInformation && (
              <>, {addressList[selectedAddressIndex]?.additionalInformation}</>
            )}
            {addressList[selectedAddressIndex]?.suburb && (
              <>, {addressList[selectedAddressIndex]?.suburb}</>
            )}
            {addressList[selectedAddressIndex]?.city && (
              <>, {addressList[selectedAddressIndex]?.city}</>
            )}
            {addressList[selectedAddressIndex]?.state && (
              <>-{addressList[selectedAddressIndex]?.state}</>
            )}
          </p>
          {(addressList[selectedAddressIndex]?.contactName ||
            addressList[selectedAddressIndex]?.contactNumber ||
            addressList[selectedAddressIndex]?.contactExtension ||
            addressList[selectedAddressIndex]?.contactEmail) && (
            <p>
              CONTATO:{' '}
              {addressList[selectedAddressIndex]?.contactName
                ? addressList[selectedAddressIndex]?.contactName
                : contactName}{' '}
              {addressList[selectedAddressIndex]?.contactNumber && (
                <>
                  {addressList[selectedAddressIndex]?.contactName && <>, </>}
                  {formatToPhone(
                    String(
                      addressList[selectedAddressIndex]?.contactNumber
                    ).padStart(10, '0')
                  )}
                </>
              )}
              {addressList[selectedAddressIndex]?.contactExtension &&
                `, RAMAL ${addressList[selectedAddressIndex]?.contactExtension}`}
              {addressList[selectedAddressIndex]?.contactEmail && (
                <>, {addressList[selectedAddressIndex]?.contactEmail}</>
              )}
            </p>
          )}
        </Box>

        <TooltipWrapper style={{ marginTop: 16 }}>
          <Controller
            name="clientInternalCode"
            defaultValue=""
            control={control}
            render={({ field }) => (
              <TextField
                label="Código Interno Cliente"
                style={{ flex: maxXS && 1 }}
                {...field}
                value={(field.value = clientInternalCode)}
                onChange={(e) => {
                  setClientInternalCode(e.target.value);
                  field.onChange(e.target.value);
                }}
                onBlur={(e) => {
                  setClientInternalCode(e.target.value);
                  field.onBlur(field.onChange(e.target.value));
                }}
                inputProps={{ maxLength: 256 }}
                error={!!errors.clientInternalCode}
                helperText={errors.clientInternalCode?.message}
              />
            )}
          />
          <TooltipIcon
            title="Código identificador do sistema particular do Cliente."
            placement="top"
            className="tooltip"
          >
            <i className="far fa-question-circle" />
          </TooltipIcon>
        </TooltipWrapper>

        <Stack
          direction={maxSM ? 'column' : 'row'}
          spacing={maxSM ? 1 : 0}
          style={{
            height: !maxSM && 36.5,
            display: 'flex',
            flexDirection: maxSM && 'column',
            justifyContent: 'space-between',
            alignItems: maxSM ? 'inherit' : 'center',
            marginTop: 16,
            marginBottom: 16
          }}
        >
          <Title>Contato:</Title>

          <BtnWrapper>
            <FixedButton
              type="button"
              onClick={() => addContact()}
              disabled={!!(alternativeContact && alternativeContact2)}
              variant="contained"
              className="btnResponsive"
            >
              Adicionar Contato Alternativo
            </FixedButton>
          </BtnWrapper>
        </Stack>

        <FieldsInLineLayout className="lineResponsive">
          <Controller
            name="contactName"
            defaultValue=""
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                type="text"
                id="contact_name"
                label="Nome *"
                data-testid="requesterContactNameInput"
                // value={(field.value = contactName)}
                onChange={(e) => {
                  const { value } = e.target;
                  const regex = /^[aA-zZ\s]+$/;
                  if (!value.match(regex) && value !== '') {
                    return;
                  }
                  field.onChange(value.toUpperCase());
                  setContactName(e.target.value);
                }}
                onBlur={(e) => {
                  field.onBlur(field.onChange(e.target.value.toUpperCase()));
                }}
                error={!!errors?.contactName?.message}
                helperText={errors?.contactName?.message}
                fullWidth
                inputProps={{
                  maxLength: 256,
                  style: { textTransform: 'uppercase' }
                }}
              />
            )}
          />
          <Controller
            name="contactEmail"
            defaultValue=""
            control={control}
            render={({ field }) => (
              <TextField
                id="contact_mail"
                label="E-mail *"
                type="email"
                {...field}
                data-testid="requesterContactEmailInput"
                // value={(field.value = contactEmail)}
                onChange={(e) => {
                  setContactEmail(e.target.value);
                  field.onChange(e.target.value);
                }}
                onBlur={(e) => {
                  setContactEmail(e.target.value.toLowerCase());
                  field.onBlur(field.onChange(e.target.value.toLowerCase()));
                }}
                error={!!errors?.contactEmail?.message}
                helperText={errors?.contactEmail?.message}
                fullWidth
                inputProps={{ maxLength: 256 }}
              />
            )}
          />
          <Controller
            name="phoneNumber"
            defaultValue=""
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                id="phoneNumber"
                label="DDD + Telefone *"
                value={(field.value = formatToPhone(phoneNumber))}
                onChange={(e) => {
                  setPhoneNumber(e.target.value);
                  field.onChange(e.target.value);
                }}
                onBlur={(e) => {
                  // if (e.target.value.length > 14) {
                  //   $('#phoneNumber').mask('(00) 00000-0009');
                  // } else {
                  //   $('#phoneNumber').mask('(00) 0000-00009');
                  // }
                  field.onBlur(field.onChange(e.target.value));
                  setPhoneNumber(e.target.value);
                }}
                error={!!errors?.phoneNumber?.message}
                helperText={errors?.phoneNumber?.message}
                fullWidth
                inputProps={{ maxLength: 50 }}
                className="telResponsive"
              />
            )}
          />
          <InputContainerWidthNumber>
            <Controller
              name="extension"
              control={control}
              render={({ field }) => (
                <TextField
                  id="contact_ramal"
                  type="text"
                  label="Ramal:"
                  {...field}
                  value={(field.value = contactRamal)}
                  onChange={(e) => {
                    // remover letras
                    const regex = /^[0-9]+$/;
                    if (!e.target.value.match(regex) && e.target.value !== '') {
                      return;
                    }
                    setContactRamal(e.target.value);
                    field.onChange(e.target.value);
                  }}
                  onBlur={(e) => {
                    field.onBlur(field.onChange(e.target.value));
                  }}
                  error={!!errors?.extension?.message}
                  helperText={errors?.extension?.message}
                  fullWidth
                  inputProps={{ maxLength: 8 }}
                  sx={{ minWidth: '110px' }}
                />
              )}
            />
          </InputContainerWidthNumber>
        </FieldsInLineLayout>

        {alternativeContact && (
          <>
            <br />
            <SectionTitleContainer>
              <SectionTitle className="titleContactResponsive">
                Contato alternativo
              </SectionTitle>
              <FixedButton
                type="button"
                onClick={(e) => {
                  setAlternativeContact(!alternativeContact);
                  removeContactAlternative();
                }}
                variant="contained"
                className="btnResponsive"
              >
                Remover Contato Alternativo
              </FixedButton>
            </SectionTitleContainer>
            <FieldsInLineLayout className="lineResponsive">
              <Controller
                name="alternativeContactName"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactName?.message}
                    helperText={errors?.alternativeContactName?.message}
                    id="alternative_contact_name"
                    label={isRequiredAlternativeContact ? 'Nome *' : 'Nome'}
                    type="text"
                    fullWidth
                    value={(field.value = alternativeContactName)}
                    onChange={(e) => {
                      const regex = /^[aA-zZ\s]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }
                      setAlternativeContactName(e.target.value.toUpperCase());
                      field.onChange(e.target.value.toUpperCase());
                    }}
                    onBlur={(e) => {
                      setAlternativeContactName(
                        e.target.value.toUpperCase().trim()
                      );
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase().trim())
                      );
                    }}
                    inputProps={{
                      maxLength: 256,
                      style: { textTransform: 'uppercase' }
                    }}
                  />
                )}
              />
              <Controller
                name="alternativeContactEmail"
                control={control}
                render={({ field }) => (
                  <TextField
                    id="alternative_contact_mail"
                    label={isRequiredAlternativeContact ? 'E-mail *' : 'E-mail'}
                    {...field}
                    error={!!errors?.alternativeContactEmail?.message}
                    helperText={errors?.alternativeContactEmail?.message}
                    type="email"
                    value={(field.value = alternativeContactEmail)}
                    onChange={(e) => {
                      setAlternativeContactEmail(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setAlternativeContactEmail(e.target.value.toLowerCase());
                      field.onBlur(
                        field.onChange(e.target.value.toLowerCase())
                      );
                    }}
                    fullWidth
                    inputProps={{ maxLength: 256 }}
                  />
                )}
              />
              <Controller
                name="alternativeContactPhone"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactPhone?.message}
                    helperText={errors?.alternativeContactPhone?.message}
                    id="alternativeContactPhone"
                    label={
                      isRequiredAlternativeContact
                        ? 'DDD + Telefone *'
                        : 'DDD + Telefone'
                    }
                    value={
                      (field.value = formatToPhone(alternativeContactPhone))
                    }
                    onChange={(e) => {
                      setAlternativeContactPhone(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      if (e.target.value.length > 14) {
                        $('#alternativeContactPhone').mask('(00) 00000-0009');
                      } else {
                        $('#alternativeContactPhone').mask('(00) 0000-00009');
                      }
                      field.onBlur(field.onChange(e.target.value));
                      setAlternativeContactPhone(e.target.value);
                    }}
                    fullWidth
                    inputProps={{ maxLength: 50 }}
                    className="telResponsive"
                  />
                )}
              />
              <InputContainerWidthNumber>
                <Controller
                  name="alternativeExtension"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={!!errors?.alternativeExtension?.message}
                      helperText={errors?.alternativeExtension?.message}
                      id="alternative_contact_ramal"
                      label="Ramal:"
                      fullWidth
                      value={(field.value = alternativeContactExtension)}
                      onChange={(e) => {
                        const regex = /^[0-9]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }
                        setAlternativeContactExtension(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      onBlur={(e) => {
                        setAlternativeContactExtension(e.target.value);
                        field.onBlur(field.onChange(e.target.value));
                      }}
                      inputProps={{ maxLength: 50 }}
                      sx={{ minWidth: '110px' }}
                    />
                  )}
                />
              </InputContainerWidthNumber>
            </FieldsInLineLayout>
          </>
        )}
        {alternativeContact2 && (
          <>
            <br />
            <SectionTitleContainer className="titleContactResponsive">
              <SectionTitle>Contato alternativo</SectionTitle>
              <FixedButton
                type="button"
                onClick={() => {
                  setAlternativeContact2(!alternativeContact2);
                  removeContactAlternative2();
                }}
                variant="contained"
                className="btnResponsive"
              >
                Remover Contato Alternativo
              </FixedButton>
            </SectionTitleContainer>
            <FieldsInLineLayout className="lineResponsive">
              <Controller
                name="alternativeContactName2"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactName2?.message}
                    helperText={errors?.alternativeContactName2?.message}
                    id="alternative_contact_name2"
                    label={isRequiredAlternativeContact2 ? 'Nome *' : 'Nome'}
                    type="text"
                    fullWidth
                    value={(field.value = alternativeContactName2)}
                    onChange={(e) => {
                      const regex = /^[aA-zZ\s]+$/;
                      if (
                        !e.target.value.match(regex) &&
                        e.target.value !== ''
                      ) {
                        return;
                      }
                      setAlternativeContactName2(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setAlternativeContactName2(
                        e.target.value.toUpperCase().trim()
                      );
                      field.onBlur(
                        field.onChange(e.target.value.toUpperCase().trim())
                      );
                    }}
                    inputProps={{
                      maxLength: 256,
                      style: { textTransform: 'uppercase' }
                    }}
                  />
                )}
              />
              <Controller
                name="alternativeContactEmail2"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactEmail2?.message}
                    helperText={errors?.alternativeContactEmail2?.message}
                    id="alternative_contact_mail2"
                    label={
                      isRequiredAlternativeContact2 ? 'E-mail *' : 'E-mail'
                    }
                    type="email"
                    fullWidth
                    value={(field.value = alternativeContactEmail2)}
                    onChange={(e) => {
                      setAlternativeContactEmail2(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      setAlternativeContactEmail2(e.target.value.toLowerCase());
                      field.onBlur(
                        field.onChange(e.target.value.toLowerCase())
                      );
                    }}
                    inputProps={{ maxLength: 256 }}
                  />
                )}
              />
              <Controller
                name="alternativeContactPhone2"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    error={!!errors?.alternativeContactPhone2?.message}
                    helperText={errors?.alternativeContactPhone2?.message}
                    id="alternativeContactPhone2"
                    label={
                      isRequiredAlternativeContact2
                        ? 'DDD + Telefone *'
                        : 'DDD + Telefone'
                    }
                    type="text"
                    fullWidth
                    value={
                      (field.value = formatToPhone(alternativeContactPhone2))
                    }
                    onChange={(e) => {
                      setAlternativeContactPhone2(e.target.value);
                      field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                      if (e.target.value.length > 14) {
                        $('#alternativeContactPhone2').mask('(00) 00000-0009');
                      } else {
                        $('#alternativeContactPhone2').mask('(00) 0000-00009');
                      }
                      field.onBlur(field.onChange(e.target.value));
                      setAlternativeContactPhone2(e.target.value);
                    }}
                    inputProps={{ maxLength: 50 }}
                    className="telResponsive"
                  />
                )}
              />
              <InputContainerWidthNumber>
                <Controller
                  name="alternativeExtension2"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={!!errors?.alternativeExtension2?.message}
                      helperText={errors?.alternativeExtension2?.message}
                      id="alternative_contact_ramal2"
                      label="Ramal:"
                      fullWidth
                      value={(field.value = alternativeContactExtension2)}
                      onChange={(e) => {
                        const regex = /^[0-9]+$/;
                        if (
                          !e.target.value.match(regex) &&
                          e.target.value !== ''
                        ) {
                          return;
                        }
                        setAlternativeContactExtension2(e.target.value);
                        field.onChange(e.target.value);
                      }}
                      inputProps={{ maxLength: 50 }}
                      sx={{ minWidth: '110px' }}
                    />
                  )}
                />
              </InputContainerWidthNumber>
            </FieldsInLineLayout>
          </>
        )}
      </Paper>

      <StepButtons nextFunction={handleSubmit(onNextStep)} />
    </form>
  );
};
